import * as React from 'react';
import { isBrowserClient } from '../utils/commonUtil';
export default function useLayoutEffect(effect, deps) {
    if (isBrowserClient) {
        React.useLayoutEffect(effect, deps);
    }
    else {
        React.useEffect(effect, deps);
    }
}
